import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from '../../services/common/common.service';
import { commonListButton } from '../../../appconfig';
import { ToasterService } from '../../services/common';

@Component({
  selector: 'app-common-list',
  templateUrl: './common-list.component.html',
  styleUrl: './common-list.component.scss'
})
export class CommonListComponent implements OnInit {
  @Output() setValues = new EventEmitter<any>();
  @Output() hideModal = new EventEmitter<any>();
  @Input() columns: any;
  @Input() gridData: any;
  @Input() okButton: string = commonListButton.ok;
  @Input() cancelButton: string = commonListButton.cancel;

  columnDefs!: any[];
  defaultColDef: any;
  filterTerm!: string;
  overlayNoRowsTemplate: string = '<span>No records found</span>';
  selectedRows: any

  get hasSelection(): boolean {
    if (this.selectedRows == null) return false;
    if (Array.isArray(this.selectedRows) && this.selectedRows.length === 0) return false;
    return true;
  }

  constructor(public commonService: CommonService, private toasterService: ToasterService) {

  }

  ngOnInit() {
    this.columnDefs = this.columns;
  }

  //emit the selected rows of customer grid
  onSubmit(event: Event) {
    // const filteredResult = this.gridData?.filter((val: any) => {
    //   return val.selection === true;
    // });
    if (this.selectedRows == null || (Array.isArray(this.selectedRows) && this.selectedRows.length == 0)) {
      this.toasterService.showError("Please select at least one record.");
      return;
    }
    this.setValues.emit(this.selectedRows);
  }

  //get current selected rows when a user click on any row. In case of redio button only last selected row will be returned
  //while in case of checkbox only rows checked will be returned.
  onRowChange(data: any) {
    //since current row selection records are comming from common table component. it may come as 
    //single record (for radio button) or multiple records (array) for checkbox selection
    //we will emit this as it ias and in concenred/consuming component/methods will be knowing if record are expected to be
    //radio button/checkbox and will handle data accordingly
    this.selectedRows = data
  }

  //method use to hide the modal
  Close() {
    this.hideModal.emit();
  }

  /**
   * Common FIlter And Search Bar
   */
  search() {
    this.commonService.searchText(this.gridData, this.filterTerm);
  }
}
